module.exports = __webpack_public_path__ + "media/images/views/talent/benefit-man-b0fd88f560de898590047cc606897bbc.png";